import { useRef } from 'react';
import classNames from 'classnames';
import { useInView } from 'framer-motion';

interface Props {
  hiddenClass: string;
  visibleClass: string;
  once?: boolean;
  amount?: 0 | 0.5 | 1;
  className?: string;
  children: string | string[] | JSX.Element | JSX.Element[];
}

function InViewAnimate({
  hiddenClass,
  visibleClass,
  once = true,
  amount = 0,
  className,
  children
}: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, amount });
  return (
    <div
      className={classNames([
        className,
        isInView ? visibleClass : hiddenClass
      ])}
      ref={ref}
    >
      {children}
    </div>
  );
}

export default InViewAnimate;
